/**
 * @packageDocumentation
 * @module f1/string
 */

import { t_simple_value } from '../types';

export interface Join {
  /**
   * Join an array of values with a string
   *
   * @public
   * @function f1.join
   * @param glue the characters to place between each
   * @param arr the string to join together
   * @example
   *
   * ```ts
   * f1.join('-', ['first', 'part']) === 'first-part'
   * ```
   */
  (glue: string, arr: t_simple_value[]): string;
  (glue: string): (arr: t_simple_value[]) => string;
}

/**
 * @see Join
 */
export default (glue: string, arr: t_simple_value[]) => {
  return arr.join(glue);
};
